<template>
  <nuxt-link
    :to="route"
    class="w-full md:w-auto hover:bg-blue-100 hover:text-blue-900 bg-blue-900 text-white md:bg-transparent md:text-blue-900 font-bold py-2 px-4 mt-2 md:mt-0 rounded inline-flex items-center border-transparent border-b-2 "
  >
    <slot></slot>
    <span>{{ label || route }}</span>
  </nuxt-link>
</template>

<script>
export default {
  props: {
    // required
    route: {
      type: String,
      required: true
    },
    // optional
    label: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>
<style lang="postcss" scoped>
.nuxt-link-active {
  @apply border-blue-800;
}
</style>
